module.exports = __webpack_public_path__ + "static/media/ic-dragdrop-image.00f632b0.svg";